import { useEffect, useState } from 'react';
import { DEMO_WHEEL_STATUS, fetchWheelStatus, isLiveTestWheel } from './luckyWheelApi';
import { LuckyWheelModal } from './LuckyWheelModal';
import type { SpinResult, WheelStatus } from './wheelTypes';

interface LuckyWheelHostProps {
  open: boolean;
  onClose: () => void;
}

export function LuckyWheelHost({ open, onClose }: LuckyWheelHostProps) {
  const [status, setStatus] = useState<WheelStatus>(DEMO_WHEEL_STATUS);

  useEffect(() => {
    let cancelled = false;
    void fetchWheelStatus()
      .then((next) => {
        if (!cancelled) setStatus(next);
      })
      .catch(() => {
        if (!cancelled) setStatus(DEMO_WHEEL_STATUS);
      });
    return () => {
      cancelled = true;
    };
  }, [open]);

  const onSpun = (result: SpinResult) => {
    if (isLiveTestWheel(result) || (!result.demo && result.credited)) {
      setStatus((prev) => ({
        ...prev,
        available: false,
        lastPrizeId: result.prizeId,
        lastAmountAzn: result.amountAzn,
        demo: false,
        testMode: Boolean(result.testMode),
        ledger: result.ledger ?? prev.ledger,
        testBalanceMinor: result.testBalanceMinor ?? prev.testBalanceMinor,
        testExpiresAt: result.testExpiresAt ?? prev.testExpiresAt,
        withdrawalEligible: false,
      }));
    }
  };

  return <LuckyWheelModal open={open} status={status} onClose={onClose} onSpun={onSpun} />;
}

/** @deprecated Homepage preview removed; use LuckyWheelHost from Layout. */
export function LuckyWheelSection() {
  return null;
}
